<template>
	<v-dialog v-model="isDialogShow" persistent max-width="460">
		<v-card>
			<v-card-title class="h6 justify-start cl-primary">Sukses Transfer</v-card-title>
			<v-card-text class="text-left">
				<div class="d-block text-left">
					<div>Selamat Anda berhasil melakukan transfer saldo dengan detail</div>
					<div class="pt-3 d-flex">
						<div class="pa-0 col-6 col-sm-4">Kode Penerima</div>
						<div class="pa-0 col-6 col-sm-8 font-weight-bold text-uppercase">: {{ msg.ewallet_product_transfer_receiver_network_code }}</div>
					</div>
					<div class="pt-1 d-flex">
						<div class="pa-0 col-6 col-sm-4">Nama Penerima</div>
						<div class="pa-0 col-6 col-sm-8 font-weight-bold">: {{ msg.ewallet_product_transfer_receiver_member_name }}</div>
					</div>
					<div class="pt-1 d-flex">
						<div class="pa-0 col-6 col-sm-4">Nominal Transfer</div>
						<div class="pa-0 col-6 col-sm-8 font-weight-bold">: {{ msg.ewallet_product_transfer_value | toRupiah }}</div>
					</div>
					<div class="pt-1 d-flex">
						<div class="pa-0 col-6 col-sm-4">Tanggal</div>
						<div class="pa-0 col-6 col-sm-8 font-weight-bold">: {{ msg.ewallet_product_transfer_datetime | tanggal }}</div>
					</div>
					<div class="pt-1 d-flex">
						<div class="pa-0 col-6 col-sm-4">Jam</div>
						<div class="pa-0 col-6 col-sm-8 font-weight-bold">: {{ msg.ewallet_product_transfer_datetime | jam }}</div>
					</div>
					<div class="pt-1 d-flex">
						<div class="pa-0 col-6 col-sm-4">Catatan</div>
						<div class="pa-0 col-6 col-sm-8 font-weight-bold">: {{ msg.ewallet_product_transfer_note }}</div>
					</div>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" outlined class="text-capitalize" :loading="btnLoading" @click.stop="modalHide">{{ closeText }}</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data () {
		return {
			isDialogShow: false,
			btnLoading: false,
			closeText: 'Tutup',
		}
	},
	props: {
		msg: Object,
	},
	computed: {
	},
	methods: {
		modalHide() {
			this.isDialogShow = false
		},
		modalShow() {
			this.isDialogShow = true
		},
		confirm() {
			this.$emit('action')
		}
	}
};
</script>